<template>
  <section class="top-user-container">
    <div class="oh-elvas-logo-area">
      
    </div>
    <div class="top-right-container">
      <div>
        <p>Guia da Cidade de Elvas</p>
        <h4>Aceder à conta</h4>
        <p class="error-text" v-if="notificationLogin && notificationLogin.element === 'general'">{{notificationLogin.text}}</p>
        <p>Email</p>
        <input v-model="email" name="email" placeholder="Inserir Email" :class="{'error': notificationLogin && (notificationLogin.element === 'email' || notificationLogin.element === 'general')}">
        <p class="error-text" v-if="notificationLogin && notificationLogin.element === 'email'">{{notificationLogin.text}}</p>
        <p class="password-text">Password</p>
        <input type="password" v-model="password" name="password" placeholder="Inserir Password" :class="{'error': notificationLogin && (notificationLogin.element === 'password' || notificationLogin.element === 'general')}">
        <p class="error-text" v-if="notificationLogin && notificationLogin.element === 'password'">{{notificationLogin.text}}</p>
        <section><elvas-button :button="{title: 'Entrar'}" @click.native="login()"/></section>
        <article>
          <elvas-button class="google" :button="{title: 'Continuar com o google'}" @click.native="logInWithGoogle()"/>
          <elvas-button class="facebook" :button="{title: 'Continuar com o facebook'}" @click.native="logInWithFacebook()"/>
        </article>
        <span class="register-url">Não tem conta? <router-link to="/user/register">Criar aqui</router-link></span>
      </div>
    </div>
  </section>
</template>
<script>
import ElvasButton from '../../components/elvas-button.vue'

export default {
  name: 'user',
  components: {
    ElvasButton
  },
  data() {
    return {
      logged: false,
      email: null,
      password: null,
      notificationLogin: null
    }
  },
  mounted () {
    if (this.$store.state.user) this.logged = true
  },
  methods: {
    async login () {
      this.notificationLogin = null
      let errorMessage = 'Erro com o login'
      let element = 'general'
      if (!this.email || !this.password) {
        if (!this.password) {
          element = 'password'
          this.notificationLogin = { text: 'Password em falta', type: 'error', element }
        }
        if (!this.email) {
          element = 'email'
          this.notificationLogin = { text: 'Email em falta', type: 'error', element }
        }
        return
      }
      let response = await this.$store.dispatch('login', {email: this.email, password: this.password})
      if (response.data && response.data.success && response.data.user) {
        this.logged = true
        if (!response.data.user.is_admin) this.$router.push('/user/dashboard/informacao-pessoal')
        else this.$router.push('/admin/interestPoints')
      } else {
        if (!response) return
        if (response.status === 422) {
          if (response.data.email) {
            errorMessage = 'Email invalido ou em falta'
            element = 'email'
          } else if (response.data.password) {
            errorMessage = 'Password invalida ou em falta'
            element = 'password'
          }
        }
        if (response.status === 401) {
          errorMessage = 'Email ou Password incorretos'
          element = 'general'
        }
        this.password = null
        this.notificationLogin = { text: errorMessage, type: 'error', element: element }
      }
    },
    async logInWithFacebook() {
      FB.login((response) => {
        if (response.authResponse) {
          let login = this.$store.dispatch('retrieveUserInfoFacebook', response.authResponse)
          login.then(response => {
            this.$router.push('/user/dashboard/informacao-pessoal')
          })
          .catch(error => {
            if (error.response.data.message === 'An user with this email already exists. Try to login with another authentification method.') {
              this.notificationLogin = {type: 'error', text: 'Este email ja se encontra registado. Tente outro metodo de login', element: 'general'}
            } else {
              this.notificationLogin = {type: 'error', text: 'Login com Facebook falhou', element: 'general'}
            }
          })
        } else {
          this.notificationLogin = {type: 'error', text: 'Ocorreu um erro no login com Facebook', element: 'general'}
        }
      }, {scope: 'public_profile,email'});
      return false;
    },
    async logInWithGoogle() {
      window.auth2.signIn().then(googleUser => {
        let login = this.$store.dispatch('retrieveUserInfoGoogle', googleUser.getAuthResponse())
          login.then(response => {
            this.$router.push('/user/dashboard/informacao-pessoal')
          })
          .catch(error => {
            if (error.response.data.message === 'An user with this email already exists. Try to login with another authentification method.') {
              this.notificationLogin = {type: 'error', text: 'Este email ja se encontra registado. Tente outro metodo de login', element: 'general'}
            } else {
              this.notificationLogin = {type: 'error', text: 'Login com Google falhou', element: 'general'}
            }
          })
      }).catch(error => {
          this.notificationLogin = {type: 'error', text: 'Ocorreu um erro no login com o Google', element: 'general'}
      })
    },
    async logout () {
      this.$store.dispatch('logout')
      this.$router.push('/user')
      this.logged = false
    }
  }
}
</script>
<style lang="scss" scoped>
.user-page-container {
  display: flex;
  min-height: 100vh;
  h4 {
    font-size: 26px;
    margin-top: 60px;
    margin-left: 20px;
    font-weight: bold;
    line-height: 0.92;
  }
  h5 {
    font-size: 26px;
    margin-left: 20px;
    line-height: 0.92;
  }
  .sidebar {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 220px;
    box-shadow: 4px 4px 4px rgba(0, 0, 0, 0.1);
    background: #f6b92f;
    color: white;
    .sidebar-links {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      padding: 20px 0;
      li {
        a {
          padding: 20px;
          display: block;
          color: white;
          font-weight: bold;
          opacity: 0.5;
          &.router-link-exact-active {
            background: #f6b92f;
            color: white;
            opacity: 1;
          }
        }
      }
    }
  }
}
.user-page-login-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  .top-user-container {
    display: flex;
    flex-grow: 1;
    & > div {
      width: 50%;
    }
    .top-right-container {
      margin-bottom: 56px;
      div:not(.elvas-button) {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding-left: 8vw;
        padding-right: 8vw;
      }
      h4 {
        margin-top: 128px;
        margin-bottom: 48px;
        font-family: Sen;
        font-size: 48px;
        font-weight: bold;
        line-height: 1.13;
        letter-spacing: -0.86px;
        color: #a79374;
      }
      p:not(.error-text) {
        margin-top: 16px;
        font-family: Sen;
        font-size: 16px;
        font-weight: bold;
        color: #a79374;
        &.password-text {
          margin-top: 40px;
        }
      }
      .error-text {
        font-size: 12px;
        color: #ff4040;
        margin-top: 8px;
      }
      input {
        margin-top: 16px;
        padding: 12px 16px;
        font-family: Sen;
        font-size: 16px;
        font-weight: bold;
        color: #d39e27;
        border: solid 1px #f6ede0;
        outline: #d39e27;
        &::placeholder {
          color: rgba(211, 158, 39, 0.5);
        }
        &.error {
          border: solid 1px #ff4040;
        }
      }
      .elvas-button {
        margin-top: 40px;
        &.google {
          background: #0075f0;
        }
        &.facebook {
          background: #3668b8;
          margin-top: 16px;
          margin-right: 0;
        }
      }
      article {
        display: flex;
        flex-direction: column;
      }
      .register-url {
        color: black;
        margin-top: 48px;
        a {
          color: #f6b92f;
          font-weight: bold;
        }
      }

    }
    @media(max-width: 750px){
      display: flex;
      flex-direction: column;
      overflow-y: hidden;
      & > div {
        width: 100%;
      }

      .oh-elvas-logo-area {
        height: 150px;
      }

      .top-right-container h4{
        margin: 24px 0;
      }
    }
  }
  .oh-elvas-logo-area {
    display: flex;
    background: #f8edde;
    align-items: center;
    div {
      display: flex;
      flex-direction: column;
      margin: 0 auto;
    }
    img {
    }
    p {
      text-align: center;
      font-family: Sen;
      font-size: 22px;
      font-weight: bold;
      line-height: 1.14;
      color: #a79374;
      margin-top: 30px;
    }
  }
  .bottom-user-container {
    display: flex;
    min-height: 125px;
    width: 100%;
    background: #a79374;
    section {
      flex-grow: 1;
      display: flex;
      align-items: center;
      padding-left: 80px;
      .flex {
        display: flex;
        align-items: center;
      }
      a {
        color: white;
        display: block;
        &:first-of-type {
          margin-bottom: 8px;
        }
      }
      p {
        margin-left: 16px;
        color: #eee3d4;
      }
    }
  }
}
</style>
<style lang="postcss">
.user-medium-bold-text {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.22;
  letter-spacing: -0.4px;
  color: #000000;
}
.user-medium-bold-text-brown {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.22;
  letter-spacing: -0.4px;
  color: #a79374;
}
.user-small-bold-text-brown {
  font-size: 16px;
  font-weight: bold;
  color: #a79374;
}
.user-small-text-brown {
  color: #a79374;
  font-size: 16px;
}
</style>